import { Injectable } from '@angular/core';
import { Subscription, gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class ArrangementCreatedGQLService extends Subscription {
  document = gql`
    subscription onNotifyArrangementCreated {
      onNotifyArrangementCreated {
        arrangementId
      }
    }
  `;
}
